export type SubSnapshot = {
  status?: string | null
  current_period_end?: string | null
  is_trial?: boolean | null
  trial_ends_at?: string | null
}

export function computePaidOk(sub?: SubSnapshot | null, nowMs: number = Date.now()): boolean {
  if (!sub) return false
  const st = String(sub.status || '').toLowerCase()
  const isTrialInternal = !!sub.is_trial
  const trialEndsIso = sub.trial_ends_at || null

  // Trial interno (sem depender apenas do status do Stripe)
  if (isTrialInternal && trialEndsIso) {
    const trialEndMs = Date.parse(trialEndsIso)
    if (Number.isFinite(trialEndMs) && nowMs <= trialEndMs) {
      return true
    }
  }

  const allowed = st === 'active' || st === 'trialing' || st === 'canceled'
  if (!allowed) return false
  const endIso = sub.current_period_end || null
  if (!endIso) return st !== 'canceled'
  const endMs = Date.parse(endIso)
  if (!Number.isFinite(endMs)) return st !== 'canceled'
  const graceMs = 60_000
  return nowMs <= (endMs + graceMs)
}
